import { serviceJsonParseReviver } from "../utils/FP.json";
import ServiceError, { ErrorDetails } from "./error";

export async function executeServiceCall<TResult = any>(
  path: string,
  payload: string,
  token: string
): Promise<TResult> {
  let response = await fetch(path, {
    body: payload,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  });
  if (response.status >= 400) {
    let details: ErrorDetails | undefined;
    let message: string | undefined;
    const statusText = response?.statusText || `HTTP Status ${response?.status || "Unspecified"}})`;
    try {
      let rawDetails = await response?.text();
      if (rawDetails) {
        details = JSON.parse(rawDetails);
        message = details?.message;
      } else {
        message = `Unknown server error (${statusText})`;
      }
    } catch (ignored) {
      message = `Unknown server error (${statusText})`;
    }
    let status = response!.status;
    // We don't currently retry for anything but an authentication error; kick out of our
    // retry cycle and report the error
    throw new ServiceError(message, details, status, statusText);
  }
  if (response.body) {
    let text = await response.text();
    if (!!text?.length) {
      return JSON.parse(text, serviceJsonParseReviver);
    }
  }
  return (undefined as unknown) as TResult;
}

